'use client';

import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';
import { Text } from '@/_components';
import { type FC, useMemo, useContext } from 'react';
import { getCookie, type CookieValueTypes } from 'cookies-next/client';
import { OVERVIEW_FIRM_ROLE_ID_COOKIE } from '@/_constants/cookies';
import type { FirmRoleCellProps } from './FirmRoleCell.types';

export const FirmRoleCell: FC<FirmRoleCellProps> = ({
  firmRoleAssignments = [],
}) => {
  const { firmUsers } = useContext(FirmSettingsContext);
  const selectedFirmRoleId: CookieValueTypes = getCookie(
    OVERVIEW_FIRM_ROLE_ID_COOKIE,
  );

  const selectedUserId: number | undefined = useMemo(
    () =>
      firmRoleAssignments.find(
        (fra) => fra.firm_role_id === parseInt(selectedFirmRoleId as string),
      )?.user_id,
    [firmRoleAssignments, selectedFirmRoleId],
  );

  const selectedFirmUserName: string | undefined = useMemo(
    () => firmUsers?.find((fu) => fu.id === selectedUserId)?.name,
    [firmUsers, selectedUserId],
  );

  return (
    <Text type="tiny" lineClamp={2}>
      {selectedFirmUserName || '-'}
    </Text>
  );
};
